import { z } from "zod";

export const CreateThemeSchema = z.object({
  event_time: z.string().optional(),
  event_description: z.string().min(1, { message: "Please provide a brief" }),
  activity: z.enum(["Campaign", "Post"]),
  campiagn_timeline: z.coerce.date().optional(),
  event_date: z.coerce.date(),
})

export type CreateThemeType = z.infer<typeof CreateThemeSchema>;

export type Template = {
  template_id: number;
  template_name: string;
  template_description: string;
  image_id: number;
  image_url: string;
  template_type: number
};

export type SocialPostType = {
  post_id: number;
  post_content: string;
  post_date: string; // ISO date string (e.g., "2025-07-01")
  post_time: string; // Time string in HH:mm:ss format
  tags: string[];
  image_video_recommendation: string;
  platform: string;
  image_url: string;
  image_id: number;
  catalogue: string;
  type: string;
  image_ids: { image_id: number, image_url: string, type: string }[] | null
}

export const PostBodyFormSchema = z.object({
  post_content: z.string().min(1, "Content is required"),
  post_id: z.number(),
  hashtags: z.array(z.string().min(1)),
  post_date: z.date(),
  post_time: z.string(),
  image_recommendation: z.string(),
  catalogue: z.string()
})

export type PostBodyFormType = z.infer<typeof PostBodyFormSchema>;

export type Platform = {
  id: number;
  name: string;
  url: string;
};

